import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { filter, map, tap } from 'rxjs/operators';
import { PermissionService } from '../_shared/services/permission.service';

@Injectable({
    providedIn: 'root',
})
export class ForbiddenAuthGuardService implements CanActivate {
    constructor(private permissionService: PermissionService, private router: Router) {}

    public canActivate() {
        return this.permissionService.isUserAuthorized$.pipe(
            filter((v) => v !== undefined),
            map((v) => !v),
            tap((shouldDisplayForbiddenPage) => {
                if (shouldDisplayForbiddenPage === false) {
                    this.router.navigate(['overview']);
                }
            })
        );
    }
}
